var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardContent",attrs:{"id":_vm.cardId}},[_c('img',{staticClass:"imgCard",attrs:{"alt":"team-icon","src":require('../assets/cards/' + _vm.table.card_type + '/' + _vm.mappedCardId + '.png'),"width":"100","height":"180"}})])}
var staticRenderFns = []

export { render, staticRenderFns }